<template>
  <div :class="[$ps.fullscreen, $ps.center]">
    <user-actions></user-actions>
    <v-form ref="form" class="auth-wrapper" id="sign-in-wrapper">
      <h1>sign in</h1>
      <v-text-field label="email" type="email" v-model="signInEmail" required />
      <v-text-field label="password" type="password" v-model="signInPassword" required />
      <v-card-actions>
        <v-btn color="primary" variant="text" @click="signInWithEmail(signInEmail, signInPassword)">sign in</v-btn>
      </v-card-actions>
    </v-form>
    <hr />
    <v-form ref="form" class="auth-wrapper" id="sign-up-wrapper">
      <h1>sign up</h1>
      <v-text-field label="email" type="email" v-model="signUpEmail" required />
      <v-text-field label="password" type="password" v-model="signUpPassword" required />
      <v-card-actions>
        <v-btn color="primary" variant="text" @click="signUpWithEmail(signUpEmail, signUpPassword)">sign up</v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script>
import UserActions from '@/components/UserActions.vue';

import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';

export default {
  name: 'AuthView',
  components: {UserActions},
  data () {
    return {
      signInEmail: '',
      signInPassword: '',
      signUpEmail: '',
      signUpPassword: ''
    }
  },
  methods: {
    signInWithEmail: async function (email, password) {
      try {
        await signInWithEmailAndPassword(this.$auth, email, password);

        console.log(`logged in`);
      } catch (err) {
        console.log(err);
      }
    },
    signUpWithEmail: async function (email, password) {
      try {
        const userCred = await createUserWithEmailAndPassword(this.$auth, email, password);
        const idToken = await userCred.user.getIdToken();

        console.log(`signed up, token ${idToken}`);
      } catch (err) {
        console.log(err);
      }
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  width: 50%;
  height: 45%;
  padding: 5vh;
}
</style>